module.exports = __webpack_public_path__ + "ps.svg?658c8814aa70f9ef97c7be35d136e492";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ps.svg
// module id = 1574
// module chunks = 0